export default "__VITE_ASSET__Ci7HgNEN__"